import { render, staticRenderFns } from "./ModalFrozenExperience.vue?vue&type=template&id=512e67b7&scoped=true&"
import script from "./ModalFrozenExperience.vue?vue&type=script&lang=js&"
export * from "./ModalFrozenExperience.vue?vue&type=script&lang=js&"
import style0 from "./ModalFrozenExperience.vue?vue&type=style&index=0&id=512e67b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e67b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
